export const loadIndex = () => async ({
  setState
}, {
  api,
  errorUtils
}) => {
  setState({
    isIndexLoading: true
  });
  try {
    const formIndex = await api.getFormIndex();
    setState({
      formIndex,
      isIndexLoading: false
    });
    return undefined;
  } catch (error) {
    errorUtils.reportError(error, {
      id: 'loadIndex'
    });
    setState({
      isIndexLoading: false
    });
    return Promise.reject(error);
  }
};